import PageShell from './PageShell';

export default function NotFoundPage() {
  return (
    <PageShell>
      <div className="max-w-3xl mx-auto py-24 text-text-main">
        <h1 className="font-serif text-4xl md:text-5xl mb-6 tracking-wide">Pagina niet gevonden</h1>
        <p className="text-secondary leading-relaxed mb-10">
          Deze pagina bestaat niet of is verplaatst. Ga terug naar de homepage van Project LEO.
        </p>
        <a
          href="/"
          className="inline-block bg-primary text-white px-8 py-4 text-sm tracking-widest uppercase hover:bg-text-main transition-colors"
        >
          Naar de homepage
        </a>
      </div>
    </PageShell>
  );
}
